import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class IsciIzinTalepAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "IsciIzinTalep";
        super(baseUrl);
    }

    ismIzinTalepList(request: IsmIzinTalepListRequest) {
        return this.post("IsmIzinTalepList", request );
    }

    ismIzinTalepDel(request: IsmIzinTalepDelRequest) {
        return this.post("IsmIzinTalepDel", request );
    }

    ismIzinTalepGet(request: IsmIzinTalepGetRequest) {
        return this.post("IsmIzinTalepGet", request );
    }

    ismIzinTalepDetayList(request: IsmIzinTalepDetayListRequest) {
        return this.post("IsmIzinTalepDetayList", request );
    }

    ismIzinDurumList(request: IsmIzinDurumListRequest) {
        return this.post("IsmIzinDurumList", request );
    }

    ismIzinTalepSave(request: IsmIzinTalepSaveRequest) {
        return this.post("IsmIzinTalepSave", request );
    }

    ismIzinTalepDurumUpd(request: IsmIzinTalepDurumUpdRequest) {
        return this.post("IsmIzinTalepDurumUpd", request );
    }

    ismIzinSuresiBul(request: IsmIzinSuresiBulRequest) {
        return this.post("IsmIzinSuresiBul", request );
    }
}
export default new IsciIzinTalepAPI();

class IsmIzinTalepListRequest {
    memurIsci?: string;
    qtSicilId?: number;

    constructor(
        memurIsci?: string,
        qtSicilId?: number,
    ) {
        this.memurIsci = memurIsci;
        this.qtSicilId = qtSicilId;
    }
}
export { IsmIzinTalepListRequest };

class IsmIzinTalepDelRequest {
    sqId?: number;

    constructor(
        sqId?: number,
    ) {
        this.sqId = sqId;
    }
}
export { IsmIzinTalepDelRequest };

class IsmIzinTalepGetRequest {
    sqId?: number;

    constructor(
        sqId?: number,
    ) {
        this.sqId = sqId;
    }
}
export { IsmIzinTalepGetRequest };

class IsmIzinTalepDetayListRequest {
    rfIsmIzinTalep?: number;

    constructor(
        rfIsmIzinTalep?: number,
    ) {
        this.rfIsmIzinTalep = rfIsmIzinTalep;
    }
}
export { IsmIzinTalepDetayListRequest };

class IsmIzinDurumListRequest {
    rfIsmOzlukBilgi?: number;
    perIzinTuruTnmDetay?: number;
    dtIslemTarihi?: Date;

    constructor(
        rfIsmOzlukBilgi?: number,
        perIzinTuruTnmDetay?: number,
        dtIslemTarihi?: Date
    ) {
        this.rfIsmOzlukBilgi = rfIsmOzlukBilgi;
        this.perIzinTuruTnmDetay = perIzinTuruTnmDetay;
        this.dtIslemTarihi = dtIslemTarihi;
    }
}
export { IsmIzinDurumListRequest };

class IsmIzinTalepSaveRequest {
    sqId?: number;
    rfIsmOzlukBilgi?: number;
    rfPerIzinTuruTanimiDetay?: number;
    rfOrtIletisimMaster?: number;
    rfIscIzinHakedisBilgi?: number;
    dtTalepTarihi?: Date;
    dtBaslangicTarihi?: Date;
    dtBitisTarihi?: Date;
    qtIzinSuresi?: number;
    dtGoreveBaslamaTarihi?: Date;
    qtIzinBelgeNo?: string;
    chIzinAdres?: string;
    qtYolIzni?: number;
    chAciklama?: string;
    qtIzinSaat?: number;
    username?: string;
    dtHastaneGirisSaati?: Date;
    dtHastaneCikisSaati?: Date;
    qtHastaneYolSure?: number;
    rfPerSicilBilgiVekil?: number;
    rfPerSicilBilgiOnayaSun?: number;
    rfPerSicGorevOnayaSun?: number;
    rfPerSicilBilgiUygunG?: number;
    rfPerSicGorevUygunG?: number;
    rfPerSicilBilgiOnay?: number;
    rfPerSicGorevOnay?: number;
    ctDurum?: number;
    dtDurumTarih?: Date;
    chDurumAciklama?: string;

    constructor(
        sqId?: number,
        rfIsmOzlukBilgi?: number,
        rfPerIzinTuruTanimiDetay?: number,
        rfOrtIletisimMaster?: number,
        rfIscIzinHakedisBilgi?: number,
        dtTalepTarihi?: Date,
        dtBaslangicTarihi?: Date,
        dtBitisTarihi?: Date,
        qtIzinSuresi?: number,
        dtGoreveBaslamaTarihi?: Date,
        qtIzinBelgeNo?: string,
        chIzinAdres?: string,
        qtYolIzni?: number,
        chAciklama?: string,
        qtIzinSaat?: number,
        username?: string,
        dtHastaneGirisSaati?: Date,
        dtHastaneCikisSaati?: Date,
        qtHastaneYolSure?: number,
        rfPerSicilBilgiVekil?: number,
        rfPerSicilBilgiOnayaSun?: number,
        rfPerSicGorevOnayaSun?: number,
        rfPerSicilBilgiUygunG?: number,
        rfPerSicGorevUygunG?: number,
        rfPerSicilBilgiOnay?: number,
        rfPerSicGorevOnay?: number,
        ctDurum?: number,
        dtDurumTarih?: Date,
        chDurumAciklama?: string
    ) {
        this.sqId = sqId;
        this.rfIsmOzlukBilgi = rfIsmOzlukBilgi;
        this.rfPerIzinTuruTanimiDetay = rfPerIzinTuruTanimiDetay;
        this.rfOrtIletisimMaster = rfOrtIletisimMaster;
        this.rfIscIzinHakedisBilgi = rfIscIzinHakedisBilgi;
        this.dtTalepTarihi = dtTalepTarihi;
        this.dtBaslangicTarihi = dtBaslangicTarihi;
        this.dtBitisTarihi = dtBitisTarihi;
        this.qtIzinSuresi = qtIzinSuresi;
        this.dtGoreveBaslamaTarihi = dtGoreveBaslamaTarihi;
        this.qtIzinBelgeNo = qtIzinBelgeNo;
        this.chIzinAdres = chIzinAdres;
        this.qtYolIzni = qtYolIzni;
        this.chAciklama = chAciklama;
        this.qtIzinSaat = qtIzinSaat;
        this.username = username;
        this.dtHastaneGirisSaati = dtHastaneGirisSaati;
        this.dtHastaneCikisSaati = dtHastaneCikisSaati;
        this.qtHastaneYolSure = qtHastaneYolSure;
        this.rfPerSicilBilgiVekil = rfPerSicilBilgiVekil;
        this.rfPerSicilBilgiOnayaSun = rfPerSicilBilgiOnayaSun;
        this.rfPerSicGorevOnayaSun = rfPerSicGorevOnayaSun;
        this.rfPerSicilBilgiUygunG = rfPerSicilBilgiUygunG;
        this.rfPerSicGorevUygunG = rfPerSicGorevUygunG;
        this.rfPerSicilBilgiOnay = rfPerSicilBilgiOnay;
        this.rfPerSicGorevOnay = rfPerSicGorevOnay;
        this.ctDurum = ctDurum;
        this.dtDurumTarih = dtDurumTarih;
        this.chDurumAciklama = chDurumAciklama;
    }
}
export { IsmIzinTalepSaveRequest };

class IsmIzinTalepDurumUpdRequest {
    sqId?: number;
    username?: string;

    constructor(
        sqId?: number,
        username?: string
    ) {
        this.sqId = sqId;
        this.username = username;
    }
}
export { IsmIzinTalepDurumUpdRequest };

class IsmIzinSuresiBulRequest {
    rfIsmOzlukBilgi?: number;
    rfPerIzinTuruTnmDetay?: number;
    dtBaslangicTarihi?: Date;
    dtBitisTarihi?: Date;
    qtIzinSuresi?: number;

    constructor(
        rfIsmOzlukBilgi?: number,
        rfPerIzinTuruTnmDetay?: number,
        dtBaslangicTarihi?: Date,
        dtBitisTarihi?: Date,
        qtIzinSuresi?: number
    ) {
        this.rfIsmOzlukBilgi = rfIsmOzlukBilgi;
        this.rfPerIzinTuruTnmDetay = rfPerIzinTuruTnmDetay;
        this.dtBaslangicTarihi = dtBaslangicTarihi;
        this.dtBitisTarihi = dtBitisTarihi;
        this.qtIzinSuresi = qtIzinSuresi;
    }
}
export { IsmIzinSuresiBulRequest };
